import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { Box, TextField } from '@mui/material';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';
import { customerCud, getAllCus } from '../../slices/customerSlice';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

const createCustomerSchema = yup.object().shape({
    name: yup.string().required('Please add Customer Name!'),
    address: yup.string(),
    phone: yup.string().required('Please add Phone Number!')
        .matches(/^\d{9,11}$/, 'Your Phone Number is Wrong!'),
})

const UpdateCustomer = ({ open, setOpen, oldData }) => {

    const dispatch = useDispatch()
    
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setValue
    } = useForm({
        resolver: yupResolver(createCustomerSchema)
    })

    const [isopen, setIsOpen] = React.useState(open);

    function handleClose() {
        setIsOpen(false)
        setOpen(false)
        reset();
    }

    const handleOnSubmit = async (data)=>{
        const newData = {...data, id: oldData?.id }
        await dispatch(customerCud({ method: 'put', data: newData, id: oldData?.id }))
        await dispatch(getAllCus({ method: 'get', data: null, keyword: "" }))
        handleClose()
    }

    React.useEffect(
        () => {
            if(oldData){
                setValue("name", oldData.name)
                setValue("address", oldData.address || "")
                setValue("phone", oldData.phone)
            }
            setIsOpen(open)
        }, [open]
    )

    return (
        <React.Fragment>
            <Dialog
                open={isopen}
                TransitionComponent={Transition}
                onClose={handleClose}
            >
                    <DialogContent
                        sx={{ width: 350 }}
                        >
                        <DialogTitle sx={{ pl: 0, pt: 0 }}>Update Customer</DialogTitle>
                        <form autoComplete='off' onSubmit={handleSubmit(handleOnSubmit)}>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column'
                            }}>
                                <TextField sx={{ mb: 3 }} {...register('name')} error={!!errors?.name} label='Customer Name' helperText={errors?.name?.message}></TextField>
                                <TextField sx={{ mb: 3 }} {...register('address')} error={!!errors?.address} label='Address' helperText={errors?.address?.message}></TextField>
                                <TextField {...register('phone')} error={!!errors?.phone} label='Phone Number' helperText={errors?.phone?.message}></TextField>
                            </Box>
                            <Box sx={{ mt: 3, display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                <Button onClick={handleClose}>Close</Button>
                                <Button type='submit' variant='contained'>Update</Button>
                            </Box>
                        </form>
                    </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}

export default UpdateCustomer